// BranchModal.jsx
import React, { useState, useEffect } from "react";
import QuestionCardAdmin from "../../../card/questionCardAdmin";
import SaveButton from "../../../forms/saveButton";
import CancelButton from "../../../forms/cancelButton";
import { MODALS } from "../../../../config/images";

const BranchModal = ({ 
  isOpen, 
  onClose, 
  onSave, 
  initialData = null,
  isEditing = false,
  mode = "create" 
}) => {

  const [branchQuestions, setBranchQuestions] = useState([]);

  useEffect(() => {
    if (isOpen) {
      if (initialData && Array.isArray(initialData)) {
        setBranchQuestions(initialData.map((branch, index) => ({
          id: branch.id || Date.now() + index,
          data: {
            isRequired: branch.data?.isRequired || false,
            options: branch.data?.options ? branch.data.options.map(opt => ({ 
              ...opt 
            })) : [
              { id: 1, text: "", placeholder: "Opción 1", isAddOption: false, isOtherOption: false },
              { id: 2, text: "", placeholder: "Agregar una opción", isAddOption: true, isOtherOption: false },
            ],
            selectedOption: branch.data?.selectedOption || null,
            selectedOptions: branch.data?.selectedOptions ? [...branch.data.selectedOptions] : [],
            uploadedImage: branch.data?.uploadedImage || null,
            imagePreview: branch.data?.imagePreview || null,
            questionTitle: branch.data?.questionTitle || "",
            selectedFormat: branch.data?.selectedFormat || 2,
            branches: branch.data?.branches ? { ...branch.data.branches } : {},
            hasOtherOption: branch.data?.hasOtherOption || false
          },
          order: index + 1
        })));
      } else if (initialData && initialData.branches) {
      const branchQuestionsArray = [];
      Object.values(initialData.branches).forEach(branchArray => {
        if (Array.isArray(branchArray)) {
          branchArray.forEach(branch => {
            branchQuestionsArray.push({
              id: branch.id || Date.now() + Math.random(),
              data: branch.data || {
                isRequired: false,
                options: [
                  { id: 1, text: "", placeholder: "Opción 1", isAddOption: false, isOtherOption: false },
                  { id: 2, text: "", placeholder: "Agregar una opción", isAddOption: true, isOtherOption: false },
                ],
                selectedOption: null,
                selectedOptions: [],
                uploadedImage: null,
                imagePreview: null,
                questionTitle: "",
                selectedFormat: 2,
                branches: {},
                hasOtherOption: false 
              },
              order: branchQuestionsArray.length + 1
            });
          });
        }
      });

      if (branchQuestionsArray.length > 0) {
        setBranchQuestions(branchQuestionsArray);
      } else {
        setBranchQuestions([{
          id: Date.now(),
          data: {
            isRequired: false,
            options: [
              { id: 1, text: "", placeholder: "Opción 1", isAddOption: false, isOtherOption: false },
              { id: 2, text: "", placeholder: "Agregar una opción", isAddOption: true, isOtherOption: false },
            ],
            selectedOption: null,
            selectedOptions: [],
            uploadedImage: null,
            imagePreview: null,
            questionTitle: "",
            selectedFormat: 2,
            branches: {},
            hasOtherOption: false 
          },
          order: 1
        }]);
        }
      } else {
        setBranchQuestions([{
          id: Date.now(),
          data: {
            isRequired: false,
            options: [
              { id: 1, text: "", placeholder: "Opción 1", isAddOption: false, isOtherOption: false },
              { id: 2, text: "", placeholder: "Agregar una opción", isAddOption: true, isOtherOption: false },
            ],
            selectedOption: null,
            selectedOptions: [],
            uploadedImage: null,
            imagePreview: null,
            questionTitle: "",
            selectedFormat: 2,
            branches: {},
            hasOtherOption: false 
          },
          order: 1
        }]);
      }
    }
  }, [isOpen, initialData]);

  useEffect(() => {
    if (!isOpen) {
      setBranchQuestions([{
        id: Date.now(),
        data: {
          isRequired: false,
          options: [
            { id: 1, text: "", placeholder: "Opción 1", isAddOption: false, isOtherOption: false },
            { id: 2, text: "", placeholder: "Agregar una opción", isAddOption: true, isOtherOption: false },
          ],
          selectedOption: null,
          selectedOptions: [],
          uploadedImage: null,
          imagePreview: null,
          questionTitle: "",
          selectedFormat: 2,
          branches: {}
        },
        order: 1
      }]);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSave = () => {
    const validQuestions = branchQuestions.filter(q => 
      q.data && q.data.questionTitle && q.data.questionTitle.trim() !== ""
    );

    if (validQuestions.length === 0) {
      alert("Por favor, ingresa al menos una pregunta válida");
      return;
    }

    onSave(validQuestions);
    onClose();
  };

  const updateBranchQuestionData = (questionId, newData) => {
    setBranchQuestions(prevQuestions => 
      prevQuestions.map(question => 
        question.id === questionId 
          ? { ...question, data: newData }
          : question
      )
    );
  };


  const addNewBranchQuestion = () => {
    const newQuestionId = Math.max(...branchQuestions.map(q => q.id), 0) + 1;
    setBranchQuestions([...branchQuestions, { 
      id: newQuestionId, 
      data: {
        isRequired: false,
        options: [
          { id: 1, text: "", placeholder: "Opción 1", isAddOption: false, isOtherOption: false },
          { id: 2, text: "", placeholder: "Agregar una opción", isAddOption: true, isOtherOption: false },
        ],
        selectedOption: null,
        selectedOptions: [],
        uploadedImage: null,
        imagePreview: null,
        questionTitle: "",
        selectedFormat: 2,
        branches: {}
      }, 
      order: branchQuestions.length + 1 
    }]);
  };

  const deleteBranchQuestion = (questionId) => {
    if (branchQuestions.length > 1) {
      const newQuestions = branchQuestions.filter(q => q.id !== questionId);
      newQuestions.forEach((q, index) => {
        q.order = index + 1;
      });
      setBranchQuestions(newQuestions);
    }
  };

  const duplicateBranchQuestion = (questionData, questionId) => {
    const newQuestionId = Math.max(...branchQuestions.map(q => q.id)) + 1;
    const newQuestions = [...branchQuestions];
    
    const currentIndex = newQuestions.findIndex(q => q.id === questionId);
    newQuestions.splice(currentIndex + 1, 0, { 
      id: newQuestionId, 
      data: { ...questionData },
      order: currentIndex + 2
    });
    
    newQuestions.forEach((q, index) => {
      q.order = index + 1;
    });
    
    setBranchQuestions(newQuestions);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg p-6 max-w-4xl max-h-[90vh] overflow-y-auto relative">

        <button 
          onClick={onClose}
          className="absolute top-4 right-4 "
        >
          <img src={MODALS.CLOSE} alt="cerrar"/>
        </button>

        <h2 className="mb-4 text-xl font-itcmedium text-blue">
          {mode === "create" ? "Crear Pregunta Ramificada" : "Editar Pregunta Ramificada"}
        </h2>
        
        
        {branchQuestions.map((question, index) => (
          <div key={question.id} className="mb-6">

            <QuestionCardAdmin 
              questionData={question.data}
              onUpdate={(data) => updateBranchQuestionData(question.id, data)}
              onCopy={!isEditing ? (data) => duplicateBranchQuestion(data, question.id) : undefined} 
              onDelete={!isEditing ? () => deleteBranchQuestion(question.id) : undefined} 
              hideBranchButtons={true}
              isEditing={isEditing}
            />
          </div>
        ))}

        {!isEditing && (
        <div className="flex justify-center mt-4 mb-6">
          <button 
            onClick={addNewBranchQuestion}
            className="px-6 py-2 transition-colors border rounded-lg font-itcmedium text-blue border-blue hover:bg-blue hover:text-white"
          >
            + Agregar nueva pregunta ramificada
          </button>
        </div>
        )}

        
        <div className="flex justify-center gap-4 mt-6">
          <SaveButton title="Guardar" onClick={handleSave} />
          <CancelButton onClick={onClose} />
        </div>
      </div>
    </div>
  );
};

export default BranchModal;